$(function() {
  // Cart

  const setCartCounter = (count) => {
    const value = parseInt(count);
    if (!isNaN(value)) {
      $(".js-cart-counter").each(function () {
        if (value > 0) {
          $(this).removeClass("d-none");
        } else {
          $(this).addClass("d-none");
        }
        $(this).html(value > 0 ? (value > 99 ? "99+" : value) : "");
      });
    }
  };

  $(".js-add-to-cart").on("click", function (e) {
    e.preventDefault();

    const product_id = $(this).data("product");
    const category_id = $(this).data("category");
    // const iconBtn = $(this).data('icon');
    // const text = $(this).text();

    if (product_id && category_id) {
      $(this).prop("disabled", true);
      // if (!iconBtn) {
      //   $(this).html(
      //     '<div class="spinner-border spinner-border-sm mr-2" role="status"></div> ' +
      //       text
      //   );
      // }
      $.ajax("/shop/ajax/buy", {
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify({
          category_id: category_id,
          product_id: product_id,
        }),
      })
        .done((data) => {
          setCartCounter(data);
          $(this).prop("disabled", false);
          // if (!iconBtn) {
          //   $(this).html(text);
          // }
        })
        .fail(function (xhr) {
          // alert('Произошла ошибка');
          // handleErrorResponse(xhr);
          $(this).prop("disabled", false);
          $(this).prop("disabled", false);
          // if (!iconBtn) {
          //   $(this).html(text);
          // }
        });
    }
  });
});
